import { JetView } from 'webix-jet';
import { allpayments } from 'models/allpayments';
import { devConfig } from 'config/config';

/**
 * Class representing a report view for betting records.
 * @extends JetView
 */
export default class recordTableBetsReportView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const vthis = this; // Reference to the current instance

        // Window for displaying filter details
        const filterDetails = webix.ui({
            view: 'window',
            move: true,
            id: 'filterDetails',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Detalles del Ticket'), // Ticket details label
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the window on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'datatable',
                id: 'dtDetails', // DataTable for details
                css: 'webix_header_border webix_data_border webix_footer_border',
                select: true,
                columns: [
                    {
                        id: 'Id',
                        header: _('Ticket Det Id'), // Column header for Ticket Detail ID
                        minWidth: 100,
                        adjust: 'data', // Width adjusts to content
                        sort: 'int',
                    },
                    {
                        id: 'TicketId',
                        header: _('Ticket ID'), // Column header for Ticket ID
                        minWidth: 100,
                        adjust: 'data', // Width adjusts to content
                        sort: 'int',
                    },
                    {
                        id: 'Description',
                        header: _('Descripción'), // Column header for Description
                        width: 250,
                        sort: 'int',
                    },
                    {
                        id: 'Market',
                        header: _('Market'), // Column header for Market
                        width: 200,
                        sort: 'int',
                    },
                    { id: 'Option', header: 'Option', width: 200, sort: 'int' }, // Column header for Option
                    {
                        id: 'Odds',
                        header: _('Odds'), // Column header for Odds
                        width: 100,
                        format: webix.i18n.numberFormat, // Formatting for Odds
                        sort: 'int',
                    },
                ],
            },
        });

        // Main DataTable configuration
        return {
            view: 'datatable',
            css: 'webix_header_border webix_data_border webix_footer_border',
            select: true,
            columns: [
                {
                    id: 'Id',
                    header: _('Ticket Det Id'), // Column header for Ticket Detail ID
                    minWidth: 100,
                    adjust: 'data', // Width adjusts to content
                    sort: 'int',
                },
                {
                    id: 'TicketId',
                    header: _('Ticket ID'), // Column header for Ticket ID
                    minWidth: 100,
                    adjust: 'data', // Width adjusts to content
                    sort: 'int',
                },
                {
                    id: 'Description',
                    header: _('Descripción'), // Column header for Description
                    width: 250,
                    sort: 'int',
                },
                { id: 'Market', header: _('Market'), width: 200, sort: 'int' }, // Column header for Market
                { id: 'Option', header: 'Option', width: 200, sort: 'int' }, // Column header for Option
                {
                    id: 'Odds',
                    header: _('Odds'), // Column header for Odds
                    width: 100,
                    format: webix.i18n.numberFormat, // Formatting for Odds
                    sort: 'int',
                },
            ],
            loadahead: 0, // Load ahead configuration
            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        var url = devConfig.geturlApi() + 'null/Report/GetBetHistoryDetail'; // API endpoint for fetching bet history details

        // Recalculate ID column width after each load
        grid.attachEvent('onAfterLoad', function () {
            this.adjustColumn('Id', 'data');
            this.adjustColumn('TicketId', 'data');
        });
        $$('dtDetails').attachEvent('onAfterLoad', function () {
            this.adjustColumn('Id', 'data');
            this.adjustColumn('TicketId', 'data');
        });

        this.on(this.app, 'user:id', (idUser) => {
            // Event listener for user ID changes
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?id=' + idUser); // Load new data based on user ID
            $$('dtDetails').clearAll(); // Clear details DataTable
            $$('dtDetails').load(url + '?id=' + idUser); // Load details based on user ID
        });
    }
}

// FILE DOCUMENTED
